import { render, staticRenderFns } from "./CustomersEditPassword.vue?vue&type=template&id=7bfe1709&"
import script from "./CustomersEditPassword.vue?vue&type=script&lang=js&"
export * from "./CustomersEditPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports